import { c as _c } from "react/compiler-runtime";
import { GiftListItem } from '@/app/_components/DonationTemp/GiftListItem';
interface GiftCardSkeletonListProps {
  count: number;
}

/**
 * 답례품 검색 결과 스켈레톤. `GiftListItem`의 isLoading 모드를 재사용한다.
 */
export function GiftCardSkeletonList(t0) {
  const $ = _c(2);
  const {
    count
  } = t0;
  let t1;
  if ($[0] !== count) {
    t1 = <ul aria-busy="true" className="grid grid-cols-3 gap-x-16 gap-y-32 pb-40 mobile:grid-cols-2 mobile:gap-x-12 mobile:gap-y-24 mobile-tablet:px-20">{Array.from({
        length: count
      }, _temp)}</ul>;
    $[0] = count;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(_, index) {
  return <li key={index}><GiftListItem isLoading={true} /></li>;
}